export default {
  install(Vue) {
    let clearId
    const vm = new Vue({data: {swipeNaved: false}})
    window.addEventListener('mousewheel', (ev) => {
      if (ev.wheelDeltaY === 0 && !vm.swipeNaved) {
        clearId && clearTimeout(clearId)
        vm.swipeNaved = true
      }
    }, false)
    window.onpopstate = () => {
      clearId && clearTimeout(clearId)
      clearId = setTimeout(() => {
        vm.swipeNaved = false
        clearId = null
      }, 500)
    }
    Object.defineProperties(Vue.prototype, {
      '$swipeNaved': {
        set(newVal) {
          vm.swipeNaved = newVal
        },
        get() {
          return vm.swipeNaved
        }
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/plugin/SwipeNaved.js